import { createEntityCollectionStore } from '@recruitee/ngrx';
import type { PlacementWithoutOpening } from '@recruitee/placements-types';

type PlacementsWithoutOpeningEntity = {
  placements: PlacementWithoutOpening[];
  jobId: number;
};

const { selectors, actions, namespace, reducer } =
  createEntityCollectionStore<PlacementsWithoutOpeningEntity>()('PlacementsWithoutOpenings', {
    idSelector: entity => entity.jobId,
    customActions: adapter => ({
      fetchOne: (state, payload: { jobId: number }) =>
        adapter.markAsPending(state, { scope: null, entities: [payload.jobId] }),
    }),
  });

const PlacementsWithoutOpeningsActions = {
  fetchOne: actions.fetchOne,
  fetchOneSuccess: actions.fetchOneSuccess,
  fetchOneFailed: actions.fetchOneFailed,
};

export {
  PlacementsWithoutOpeningsActions,
  selectors as PlacementsWithoutOpeningsSelectors,
  namespace as PlacementsWithoutOpeningsNamespace,
  reducer as PlacementsWithoutOpeningsReducer,
};
